import { IconButton, Stack, Tooltip } from "@mui/material";
import { FaKey, FaMagnifyingGlass, FaPen, FaTrash, FaUsers } from "react-icons/fa6";
import { Link } from "react-router-dom";
import { deleteAdminUser, getAdminUsers } from '../../helpers/http_admin_users_requests';
import ListingPage from '../../components/DynamicListingPage';
import { CurrentSwitch } from '../../components/CurrentSwitch';
import { useMutation, useQuery } from '@tanstack/react-query'
import { usePermissions } from "../../providers/PermissionsProvider";
import { useAuth } from "../../providers/AuthProvider";
import { confirmAndExecuteFn } from '../../utils/functions';
import { useState } from "react";

export default function AdminUsers() {

    const { verifyPermission } = usePermissions();

    const [filterValues, setFilterValues] = useState({});

    const handleFilterChange = (field, value) => {
        setFilterValues(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const { data, isFetching, refetch } = useQuery({ 
        queryKey: ['getAdminUsers', filterValues], 
        queryFn: () => getAdminUsers(filterValues), 
        staleTime: 1000 * 5 
    });

    const { id: user_id } = useAuth();

    const { admin_users: users = [] } = data?.data ?? {};

    const columns = [
        { field: 'image', headerName: 'Foto', },
        {
            field: 'complete_name',
            headerName: 'Nome',
        },
        {
            field: 'whatsapp_number',
            headerName: 'Contato',
        },
        {
            field: 'title',
            headerName: 'Cargo',
            type: 'number',
        },
        {
            field: 'actions',
            headerName: 'Ações',
            type: 'number',
        },
    ];

    const deleteMutation = useMutation({
        mutationFn: (id) => deleteAdminUser(id, user_id),
        onSuccess: () => {
            setTimeout(() => {
                refetch();
            }, 1000);
        }
    });

    const handleDelete = (id) => {
        confirmAndExecuteFn('Tem certeza que deseja deletar este usuário?', () => {
            deleteMutation.mutate(id);
        });
    };

    const componentName = 'users';

    // Configuração dos filtros
    const filters = [
        { 
            field: 'is_active', 
            type: 'select', 
            label: 'Status',
            options: [
                { value: '1', label: 'Ativo' },
                { value: '0', label: 'Inativo' }
            ]
        },
    ];

    const renderActions = (row) => (
        <Stack spacing={1} direction={'row'} justifyContent={'center'}>
            <Tooltip title="Status" arrow placement="top">
                <span><IconButton disabled><CurrentSwitch title="status" status={row.is_active} /></IconButton></span>
            </Tooltip>
            {verifyPermission(componentName, 1) && (
                <Tooltip title="Ver detalhes" arrow placement="top">
                    <IconButton color="primary" LinkComponent={Link} to={`/usuario-detalhes/${row.id}`}>
                        <FaMagnifyingGlass size={20} />
                    </IconButton>
                </Tooltip>
            )}
            {verifyPermission(componentName, 2) && (
                <>
                    <Tooltip title="Permissões" arrow placement="top">
                        <IconButton color="primary" LinkComponent={Link} to={`/usuario-permissoes/${row.id}`}>
                            <FaKey size={20} />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Editar" arrow placement="top">
                        <IconButton color="primary" LinkComponent={Link} to={`/usuario-editar/${row.id}`}>
                            <FaPen size={20} />
                        </IconButton>
                    </Tooltip>
                </>
            )}
            {verifyPermission(componentName, 4) && (
                <Tooltip title="Deletar" arrow placement="top">
                    <IconButton color="error" onClick={() => handleDelete(row.id)}>
                        <FaTrash size={20} />
                    </IconButton>
                </Tooltip>
            )}
        </Stack>
    );

    return <ListingPage 
        canAddData={verifyPermission(componentName, 3)} 
        isLoading={isFetching} 
        icon={FaUsers} 
        pageTitle={"Usuários Inovart Gold"} 
        addButtonTitle={"usuário"} 
        addPath={"/usuario-cadastrar"} 
        columns={columns} 
        data={users} 
        actions={renderActions}
        filters={filters}
        filterValues={filterValues}
        onFilterChange={handleFilterChange}
    />
};